import React from 'react';
import './style.scss';
import './style.darkmode.scss';

const Icon = ({ icon }) => {
    return <span className='header-icon'>
        {icon}
    </span>;
};

export default React.memo(Icon);